const CONSTANTS = {
  BASE_HOST: 'hipages.com.au',
  BASE_URL: `https://hipages.com.au`,
  ASSETS_URL: `https://assets.homeimprovementpages.com.au`,
  THUMBNAIL_URL: `https://thumbnail-cloud.homeimprovementpages.com.au`,
  MEDIACACHE_URL: `https://mediacache.homeimprovementpages.com.au`,
  UPLOADS_URL: `https://uploads.hipages.com.au`,
  SUPPORT_EMAIL: `support@hipages.com.au`,
  INFO_EMAIL: `info@hipages.com.au`
};

export default {
  PINTEREST_URL: '//assets.pinterest.com/js/pinit.js',
  SHARE_THIS_URL: '//platform-api.sharethis.com/js/sharethis.js#product=custom-share-buttons',
  LATEST_ARTICLE_MAX_DISPLAY_AMOUNT: 8,
  ASSET_HUI_IMAGES_URL_BASE: `${CONSTANTS.ASSETS_URL}/images/hui/`,
  ARTICLE_IMAGES: {
    sizes:
      '(max-width:320px) 320px, (max-width:480px) 480px, (max-width:768px) 768px, (max-width:960px) 960px, (max-width:1180px) 1180px, 1180px',
    breakpoints: ['320', '480', '768', '960', '1180'],
    heroHeightBreakpoints: ['0', '0', '0', '380', '450'],
    heroPreloadSize: '110x42'
  },
  ARTICLE_DEFAULT_IMAGE: `${CONSTANTS.ASSETS_URL}/images/default-article.png`,
  HERO_JUMBOTRON_IMAGE_URL: `${CONSTANTS.ASSETS_URL}/images/articles-hero-bg-v2.jpg`,
  CATEGORY_PERSON_DEFAULT: 'Trade Professional',
  CATEGORY_PERSON_PLURAL_DEFAULT: 'Trade Professionals',
  SITE_SOURCE: 'Articles',
  INFO_EMAIL: CONSTANTS.INFO_EMAIL,
  ...CONSTANTS
};
